import React from "react";
import axios from "axios";
import dayjs from "dayjs";
import { useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from "./config";
import { setCookie } from "./utils";
import { CommonDataContext } from "./utils/commonProvider";
import CookiesHelper from "./utils/cookiesHelper";

const AuthGuard = ({ children, sessionHandler, setBranchName }) => {
  const voAuthToken = CookiesHelper.getAccessToken()
  const leadDetails = sessionStorage.getItem("leadDetails")
    ? JSON.parse(sessionStorage.getItem("leadDetails"))
    : null;
  const urlParams = new URLSearchParams(window.location.search);
  const authTokenValue = urlParams.get('token');
  const editLead = sessionStorage.getItem("editLead") ? JSON.parse(sessionStorage.getItem("editLead")) : null
  const agentValue = urlParams.get('agent')
  const agentUserId = urlParams.get('userId')
  const { setEditLead } = useContext(CommonDataContext)
  const navigate = useNavigate();

  useEffect(() => {
    if (editLead) setEditLead(editLead)
    else setEditLead(null)
  }, [editLead])

  useEffect(() => {
    const removeQueryParamAndRedirect = () => {
      const { pathname } = window.location;
      const newUrl = pathname;
      // deepcode ignore DOMXSS: ASK TO Senior, deepcode ignore OR: <please specify a reason of ignoring this>
      navigate(newUrl, { replace: true });
    }

    if (authTokenValue && agentValue && agentUserId) {
       
      const tokenExpiryTime = dayjs().add(1,"month")
      const cookieOptions = {
        path: '/',
        expires: new Date(tokenExpiryTime.format()),
        domain: '.starhealth.in',
        secure: false
      };
      setCookie('vo-auth-token', authTokenValue, cookieOptions);
      setCookie('vo-login-id', agentValue, cookieOptions);
      setCookie('vo-userId', agentUserId, cookieOptions);
      removeQueryParamAndRedirect();
    }
  }, [])



  useEffect(() => { 
    if (voAuthToken) {
      try {
        axios
        .get(`${API_BASE_URL}/sme-api/auth/getUserDetails`, {
          headers: {
            token: CookiesHelper.getAccessToken(),
          },
        })
        .then(({ data }) => {
          if (data && typeof data?.redirectTo === 'string') {
            sessionStorage.setItem("userType", data.userType);
            sessionStorage.setItem("branch", data.branchName);
            setBranchName(data.branchName)
            navigate(data.redirectTo)
            const cookieOptions = {
              path: '/',
              expires: new Date(tokenExpiryTime.format()),
              domain: '.starhealth.in',
              secure: false
            };
            setCookie("vo-userId", data.userId, cookieOptions);
            CookiesHelper.setCookiesData("vo-userId", data.userId)
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.error('Bad Request:', error.response.data);
            sessionHandler()
          }
        })
      } catch (error) {
        debugger
      }
    }
  }, [voAuthToken])

  useEffect(() => {
    if (!(leadDetails?.leadId) && window.location.pathname === '/quote') {
      navigate('/company-details')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {children}
    </>
  )
}

export default AuthGuard